import {CardDataController} from '@colonist/game-card-types'
import {PIXI} from '@colonist/pixi'
import {UIGamePopupCondensedCardInformationView} from './UIGamePopupCondensedCardInformationView'
import {UIGameManager} from '../UIGameManager'
import {CardEnum} from '@colonist/game-states'

export class UIGamePopupCondensedCardInformationController {
    private readonly uiGameManager: UIGameManager

    private readonly parentContainer: PIXI.Container
    private readonly x: number
    private readonly y: number
    private readonly w: number
    private readonly h: number

    condensedCardInformation: UIGamePopupCondensedCardInformationView | undefined

    constructor(uiGameManager: UIGameManager, parentContainer: PIXI.Container, x: number, y: number, w: number, validCardsToSelect: CardEnum[]) {
        this.uiGameManager = uiGameManager
        this.parentContainer = parentContainer
        this.x = x
        this.y = y
        this.w = w
        this.h = this.getLongestTextHeight(validCardsToSelect)
    }

    getLongestTextHeight(validCardsToSelect: CardEnum[]): number {
        let longestTextHeight: number = 0
        for(const selectableCard of validCardsToSelect) {
            const popupInformation = this.getSelectCardInformationForCard(selectableCard)
            if(popupInformation == undefined) continue
            if(popupInformation.parent != undefined) popupInformation.parent.removeChild(popupInformation)
            if(popupInformation.height <= longestTextHeight) continue

            longestTextHeight = popupInformation.height
        }
        const padding = this.uiGameManager.canvasController.itemSize * 0.1
        return longestTextHeight + padding
    }

    private getSelectCardInformationForCard(cardEnum: CardEnum): UIGamePopupCondensedCardInformationView | undefined {
        const cardData = CardDataController.getCardDataForCard(cardEnum)
        if(cardData == undefined) return undefined

        const marginX = this.uiGameManager.canvasController.itemSize * 0.1
        return new UIGamePopupCondensedCardInformationView(cardData, this.x + marginX, this.y, this.w, this.h, this.parentContainer)
    }

    removeSelectedCardInformation() {
        if(this.condensedCardInformation == undefined) return
        if(this.condensedCardInformation.parent != undefined) this.condensedCardInformation.parent.removeChild(this.condensedCardInformation)
        this.condensedCardInformation = undefined
    }

    showSelectedCardInformation(cardEnum: CardEnum) {
        this.removeSelectedCardInformation()
        this.condensedCardInformation = this.getSelectCardInformationForCard(cardEnum)
    }
}
